import { Injectable, InjectionToken } from '@angular/core';

/**
 * Swappable machine-vertaal-provider. Plug hier later een echte dienst in
 * (DeepL / Google Cloud Translation / LibreTranslate) achter een config-key.
 * Een implementatie mag de bronteksten teruggeven als vertalen niet mogelijk is.
 */
export interface TranslationProvider {
    /** True wanneer een echte machine-vertaaldienst is geconfigureerd. Bij false blijft de
     *  MT-fallback inert: anders zou de bron-(nl-)tekst als "vertaling" in de doeltaal belanden. */
    readonly enabled: boolean;
    translate(texts: string[], from: string, to: string): Promise<string[]>;
}

export const TRANSLATION_PROVIDER = new InjectionToken<TranslationProvider>('TRANSLATION_PROVIDER');

/** Standaardprovider: doet niets (geeft de bron terug). Veilig wanneer geen API geconfigureerd is. */
@Injectable({ providedIn: 'root' })
export class NoopTranslationProvider implements TranslationProvider {
    readonly enabled = false;
    async translate(texts: string[]): Promise<string[]> {
        return texts;
    }
}
